import { render, staticRenderFns } from "./prop.vue?vue&type=template&id=a5e88c72&scoped=true&"
import script from "./prop.vue?vue&type=script&lang=js&"
export * from "./prop.vue?vue&type=script&lang=js&"
import style0 from "./prop.vue?vue&type=style&index=0&id=a5e88c72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e88c72",
  null
  
)

export default component.exports